import { hasPermission } from '@/hooks/useBackendMenu'
import Dialog from 'global/guides/Dialog'
import { useParams } from 'react-router-dom'
import { trocaHorario as api } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { FormTrocaDiaTrabalho } from '../forms/TrocaDiaTrabalho'
import { invalidateDigitacaoQueries } from '../pages/useDigitacaoData'

interface IProps {
    disableSelects?: boolean
}

export default function NovaTrocaDiaTrabalho({ disableSelects }: IProps) {
    const { companyId, employeeId } = useStore()
    const { dia } = useParams<{ dia?: string }>()

    const { mutateAsync, isLoading } = api.diaTrabalho.mutations.useCreate({
        invalidateQuery: true,
    })

    async function handleSubmit(data: any) {
        return mutateAsync(
            {
                ...data,
                empresaId: companyId,
                funcionarioId: employeeId,
            },
            {
                onSuccess: () => {
                    toast.success('Dia de trabalho trocado com sucesso')
                    invalidateDigitacaoQueries()
                },
                onError: e => {
                    toast.error(e.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            height="auto"
            onSubmit={handleSubmit}
            loading={isLoading}
            open={hasPermission(['create', 'TrocaDeDiaDeTrabalho'])}
            defaultValues={{
                trabalha: dia,
            }}
        >
            <Dialog.Title>Adicionar troca de dia de trabalho</Dialog.Title>
            <Dialog.Content dividers>
                <FormTrocaDiaTrabalho disableSelects={disableSelects} />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
